import Button from 'components/button/Button';
import { Integration } from 'models/InternalIntegrationSetting';
import { Alert, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { ModalFooterStyled } from './EnableHostfullyDeviceModal.styles';

const PRICE_PER_DEVICE = 6;

const EnableHostfullyDeviceModal = ({
  onConfirm,
  integration,
  modalId,
}: {
  integration: Integration;
  onConfirm: () => void;
  modalId: string;
}) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();

  const integrationName = integration.displayName ?? integration.name;

  const handleCloseModal = () => {
    closeModal(modalId);
  };

  const handleAccept = () => {
    onConfirm();
    handleCloseModal();
  };

  return (
    <div>
      <Modal.Header closeButton>
        <Modal.Title>
          {t('pageIntegrations.modals.enableHostfullyDevices.title', {
            integration: integrationName,
          })}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Alert bsStyle="danger">
          {t('pageIntegrations.modals.enableHostfullyDevices.description', {
            pricePerDevice: PRICE_PER_DEVICE,
          })}
        </Alert>
      </Modal.Body>

      <Modal.Footer>
        <ModalFooterStyled>
          <Button bsStyle="default" onClick={handleCloseModal}>
            {t('common.cancel')}
          </Button>

          <div>
            <Button className="decline-button" onClick={handleCloseModal}>
              {t('pageIntegrations.modals.enableHostfullyDevices.decline')}
            </Button>
            <Button className="accept-button" onClick={handleAccept}>
              {t('pageIntegrations.modals.enableHostfullyDevices.accept')}
            </Button>
          </div>
        </ModalFooterStyled>
      </Modal.Footer>
    </div>
  );
};

export default EnableHostfullyDeviceModal;
